<template>
  <div
    class="card w-full h-full flex flex-col justify-start items-start bg-white rounded-xl p-3 lg:p-6 border-4 border-grey-300"
    :class="deployed ? '' : 'hidden'">
    <img :src="image" class="w-2/3 lg:w-1/2 mb-2 lg:mb-4 text-center items-center justify-center" />
    <p class="text-left font-semibold text-base lg:text-lg mt-2">{{ title }}</p>
    <p class="text-xs lg:text-sm text-left">{{ subtitle }}</p>

    <div @click="open"
      class="flex flex-row gap-1 text-sm text-theme-primary hover:underline font-semibold mt-2 cursor-pointer items-center">
      <p>More Details</p>
      <img src="@/assets/images/papsi_next_green.svg" class="w-4 h-4" />
    </div>

    <!-- <p @click="open" class="text-sm text-theme-primary hover:underline font-semibold mt-2 cursor-pointer">More Details</p> -->
  </div>
</template>

<script>
export default {
  name: "v-card",
  props: {
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    open: {
      type: Function,
      required: true,
    },
    deployed: {
      type: Boolean,
      default: true,
    }
  },
};
</script>

<style scoped>
.card {
  transition: all 0.2s ease-in-out;
}
</style>